import React from 'react';
import PropTypes from 'prop-types';

const CaptionImage = ({ url }) => (
  <div
    className="production__item-image"
    style={{
      backgroundPosition: 'center center',
      backgroundImage: `url(${url || '/img/placeholder.jpg'})`,
    }}
  />
);

CaptionImage.propTypes = {
  url: PropTypes.string,
};

CaptionImage.defaultProps = {
  url: '/img/placeholder.jpg',
};

export default CaptionImage;



// WEBPACK FOOTER //
// ./src/components/Caption/CaptionImage.js